class YGBulkPurchase extends HTMLElement {
    static productData = []

    constructor() {
        super()
        this.init()
    }

    init() {
        this.taggledClass()
        this.totalPrices()
        this.addToCart()
    }

    taggledClass() {
        this.querySelectorAll('.yg-bulk-purchase__product').forEach(item => {
            item.addEventListener('click', (e) => {
                if (e.target.classList.contains('quantity-selector__button') || e.target.classList.contains('quantity-selector__input')) {
                    return
                }
                item.classList.toggle('active')
                item.parentNode.parentNode.classList.toggle('active')
                this.totalPrices()
            })
        })
        this.querySelectorAll('.quantity-selector__input').forEach(quantity => {
            quantity.addEventListener('input', (e) => {
                this.totalPrices()
            })
        })
        this.querySelectorAll('.quantity-selector__button').forEach(button => {
            button.addEventListener('click', (e) => {
                this.totalPrices()
            })
        })

    }

    totalPrices() {
        let activeProducts = this.querySelectorAll('.yg-bulk-purchase__product.active')
        let totalPrice = 0
        YGBulkPurchase.productData = []

        activeProducts.forEach(active => {
            let productPriceBox = active.querySelector('.yg-bulk-purchase__product-price').getAttribute('data-price')
            let productQuantity = active.querySelector('.quantity-selector__input').value
            totalPrice += parseInt(productPriceBox) * parseInt(productQuantity)

            YGBulkPurchase.productData.push({
                'id': active.querySelector('.yg-bulk-purchase__product-price').getAttribute('data-id'),
                'quantity': productQuantity
            })
        })

        let totalPriceBox = this.querySelector('.yg-tatal-price__price')
        let currency = totalPriceBox.getAttribute('data-currency').split(' ')[1]

        totalPriceBox.innerHTML = `${currency} $${totalPrice / 100}`
    }

    addToCart() {
        this.querySelector('.yg-add-to-cart').addEventListener('click', (e) => {
            let sectionsToBundle = ["variant-added"];
            document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", {
                bubbles: true,
                detail: {sections: sectionsToBundle}
            }));
            let formData = {
                'items': YGBulkPurchase.productData,
                'sections': sectionsToBundle.join(",")
            };
            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
                .then(async response => {
                    if (response.ok) {
                        const responseJson = await response.json();
                        if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
                            return window.location.href = `${Shopify.routes.root}cart`;
                        }
                        const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
                        cartContent["sections"] = responseJson["sections"];

                        this.dispatchEvent(new CustomEvent("variant:add", {
                            bubbles: true,
                            detail: {
                                items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
                                cart: cartContent
                            }
                        }));
                        document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                            bubbles: true,
                            detail: {
                                baseEvent: "variant:add",
                                cart: cartContent
                            }
                        }));
                    } else {
                        const responseJson = await response.json();

                        this.dispatchEvent(new CustomEvent("yg_cart:error", {
                            bubbles: true,
                            detail: {
                                error: responseJson["description"]
                            }
                        }));
                        document.dispatchEvent(new CustomEvent("cart:refresh"));
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        })
    }
}

if (!window.customElements.get('yg-bulk-purchase')) {
    window.customElements.define('yg-bulk-purchase', YGBulkPurchase)
}

class YGScriptLoader extends HTMLElement {
    loadScript(url, fn) {
        if (url) {
            let loadScript = document.createElement('script')
            loadScript.src = url
            document.body.appendChild(loadScript)

            loadScript.onload = () => {
                fn()
            }

            loadScript.onerror = () => {
                console.error('Script load error')
            }
        }
    }
}

class YGPopup extends HTMLElement {
    constructor() {
        super()
        this.openPopup()
        this.clonePopup()
    }

    openPopup() {
        // 这里放置自定义逻辑
        this.addEventListener("click", function () {
            let popupBox = document.querySelector(".yg-now-popup-box")
            let popupTemplate = this.querySelector("template") || this.querySelector(".yg-popup-template")

            popupBox.querySelector('.yg-popup-box-content-inner').innerHTML = popupTemplate.innerHTML
            document.querySelector('body').style.overflow = "hidden"
            popupBox.style.display = "flex"
        })

        // const link = document.querySelector('.yg-header-top .yg-top-block a');
        // this.addEventListener("click",function(){
        //     link.click();
        // })
    }

    clonePopup() {
        let popupBox = document.querySelector(".yg-now-popup-box")
        popupBox.addEventListener("click", function (e) {
            if (e.target.className == 'yg-popup-box-close' || e.target.className == 'yg-popup-box') {
                popupBox.style.display = "none"
                popupBox.querySelector('.yg-popup-box-content-inner').innerHTML = ''
                document.querySelector('body').style.overflow = "auto"
            }
        })
    }
}

if (!window.customElements.get('yg-popup')) {
    window.customElements.define('yg-popup', YGPopup)
}

class YGNewPopup extends HTMLElement {
    constructor() {
        super()
        this.openPopup()
        this.clonePopup()
    }

    openPopup() {
        // 这里放置自定义逻辑
        this.addEventListener("click", function () {
            let popupBox = this.parentElement.querySelector(".yg-popup-box")
            document.querySelector('body').style.overflow = "hidden"
            popupBox.style.display = "flex"
        })

        // const link = document.querySelector('.yg-header-top .yg-top-block a');
        // this.addEventListener("click",function(){
        //     link.click();
        // })
    }

    clonePopup() {
        let popupBox = this.parentElement.querySelector(".yg-popup-box")
        popupBox.addEventListener("click", function (e) {
            console.log(e.target.className);
            if (e.target.className == 'yg-popup-box-close' || e.target.className == 'yg-popup-box') {
                popupBox.style.display = "none"
                document.querySelector('body').style.overflow = "auto"
            }
        })
    }
}

if (!window.customElements.get('yg-new-popup')) {
    window.customElements.define('yg-new-popup', YGNewPopup)
}

class YGOrderSavings extends HTMLElement {
    connectedCallback() {
        this.productForm = document.forms[this.getAttribute('form')]
        this.onVariantChange = this.onVariantChange.bind(this)
        this.productForm?.addEventListener('variant:change', this.onVariantChange)
        this.update({
            price: Number(this.dataset.selectedPrice),
            available: this.dataset.selectedAvailable === 'true'
        })
    }

    disconnectedCallback() {
        this.productForm?.removeEventListener('variant:change', this.onVariantChange)
    }

    onVariantChange(event) {
        this.update(event.detail.variant)
    }

    renderMessage(message, text, amount, isAchieved) {
        message.textContent = text || ''
        if (!isAchieved || !text || !amount) return

        const amountStart = text.indexOf(amount)
        if (amountStart === -1) return

        const amountElement = document.createElement('strong')
        amountElement.className = 'yg-order-savings__amount'
        amountElement.textContent = amount

        message.replaceChildren(
            document.createTextNode(text.slice(0, amountStart)),
            amountElement,
            document.createTextNode(text.slice(amountStart + amount.length))
        )
    }

    update(variant) {
        const tiers = Array.from(this.querySelectorAll('[data-order-savings-tier]'))
        const price = Number(variant?.price)
        const isAvailable = variant?.available === true

        this.hidden = !isAvailable || !Number.isFinite(price) || tiers.length === 0
        if (this.hidden) return

        let highestAchievedTier = null

        tiers.forEach((tier) => {
            const threshold = Number(tier.dataset.threshold)
            if (Number.isFinite(threshold) && price >= threshold) highestAchievedTier = tier
        })

        tiers.forEach((tier) => {
            const threshold = Number(tier.dataset.threshold)
            const isAchieved = Number.isFinite(threshold) && price >= threshold
            const isSuperseded = isAchieved && highestAchievedTier && tier !== highestAchievedTier

            tier.hidden = Boolean(isSuperseded)
            if (tier.hidden) return

            const desktopMessage = tier.querySelector('[data-order-savings-desktop]')
            const mobileMessage = tier.querySelector('[data-order-savings-mobile]')
            const achievedAmount = tier.dataset.achievedAmount

            if (desktopMessage) {
                const desktopText = isAchieved ? tier.dataset.achievedText : tier.dataset.progressText
                this.renderMessage(desktopMessage, desktopText, achievedAmount, isAchieved)
            }

            if (mobileMessage) {
                const mobileText = isAchieved
                    ? tier.dataset.achievedCompactText
                    : tier.dataset.progressCompactText
                this.renderMessage(mobileMessage, mobileText, achievedAmount, isAchieved)
            }

            tier.classList.toggle('text-success', isAchieved)
            tier.classList.toggle('text-subdued', !isAchieved)
        })
    }
}

if (!window.customElements.get('yg-order-savings')) {
    window.customElements.define('yg-order-savings', YGOrderSavings)
}

class YGCardButtons extends HTMLElement {
    constructor() {
        super()
        this.addToCartButton = this.querySelector('.yg-add-to-cart')
        this.buyNowButton = this.querySelector('.yg-buy-it-now')
        this.initialAddToCartLabel = this.addToCartButton?.textContent.trim() || ''
        this.initialBuyNowLabel = this.buyNowButton?.textContent.trim() || ''
        this.preorderStates = this.readPreorderStates()
        if (this.hasAttribute('data-follow-page-variant')) {
            document.addEventListener('variant:change', (event) => {
                if (String(event.detail.product?.id) !== this.dataset.productId) return

                const variantId = event.detail.variant?.id
                const variantInput = this.productForm?.querySelector('[name="id"]')

                if (variantInput && variantId) {
                    variantInput.value = variantId
                    variantInput.dispatchEvent(new Event('change', { bubbles: true }))
                }

                this.applyPreorderState(variantId)
            })
        }
        this.productForm = this.querySelector('form[is="product-form"]') || this.querySelector('form')
        this.bindShippingNotice()
        this.addToCart()
        this.buyItNow()
        this.observeVariantChanges()
        this.applyPreorderState(this.dataset.selectedVariantId || this.productForm?.querySelector('[name="id"]')?.value)
    }

    readPreorderStates() {
        const stateElement = this.querySelector('[data-preorder-variants]')

        if (!stateElement) return {}

        try {
            return JSON.parse(stateElement.textContent)
        } catch {
            return {}
        }
    }

    observeVariantChanges() {
        this.productForm?.addEventListener('variant:change', (event) => {
            this.applyPreorderState(event.detail.variant?.id)
        })
    }

    bindShippingNotice() {
        const noticeElement = this.closest('.yg-product-description')?.querySelector('[data-purchase-shipping-notice]')
        const closeButton = noticeElement?.querySelector('[data-purchase-shipping-close]')

        if (!noticeElement || !closeButton || noticeElement.dataset.closeBound === 'true') return

        noticeElement.dataset.closeBound = 'true'
        closeButton.addEventListener('click', () => {
            noticeElement.classList.add('is-mobile-dismissed')
        })
    }

    applyPreorderState(variantId) {
        const statusElement = this.closest('.yg-product-description')?.querySelector('[data-purchase-delivery-status]')
        const state = this.preorderStates[String(variantId)]
        if (!state) {
            if (statusElement) statusElement.textContent = ''
            return
        }
        const isPreorder = state.preorder === true
        const isBlocked = state.blocked === true
        const noticeElement = this.querySelector('.yg-preorder-message')
        const noticeValueElement = this.querySelector('.yg-preorder-message__value')

        if (statusElement) {
            statusElement.textContent = isBlocked
                ? 'Out of Stock'
                : isPreorder
                    ? state.snapshot || ''
                    : 'Estimated delivery in 3 - 8 business days.'
        }

        this.classList.toggle('is-preorder', isPreorder)
        this.classList.toggle('is-preorder-blocked', isBlocked)
        this.syncPurchaseState(isPreorder, isBlocked)
        this.syncPreorderProperty(isPreorder, state.snapshot)

        if (noticeElement) {
            noticeElement.hidden = !isPreorder || !state.notice
        }

        if (noticeValueElement) {
            noticeValueElement.textContent = isPreorder ? state.notice : ''
        }
    }

    syncPurchaseState(isPreorder, isBlocked) {
        const productSubmitButton = this.productForm?.querySelector('button[type="submit"]')

        if (this.addToCartButton) {
            this.addToCartButton.disabled = isBlocked
            this.addToCartButton.textContent = isBlocked ? 'Sold Out' : this.initialAddToCartLabel
        }

        if (this.buyNowButton) {
            this.buyNowButton.disabled = isBlocked
            this.buyNowButton.hidden = isBlocked
            this.buyNowButton.textContent = isPreorder ? 'Pre-Order' : this.initialBuyNowLabel
        }

        if (productSubmitButton) {
            productSubmitButton.disabled = isBlocked
        }
    }

    syncPreorderProperty(isPreorder, snapshot) {
        const preorderInput = this.productForm?.querySelector('[data-preorder-property]')

        if (preorderInput) {
            preorderInput.disabled = !isPreorder || !snapshot
            preorderInput.value = isPreorder ? snapshot : ''
        }
    }

    addToCart() {
        const addButton = this.querySelector('.yg-old-buttons button[type="submit"]')
        const visibleAddButton = this.querySelector('.yg-add-to-cart')

        if (!addButton || !visibleAddButton) return

        visibleAddButton.addEventListener('click', () => addButton.click())
    }

    buyItNow() {
        if (!this.buyNowButton) return

        this.buyNowButton.addEventListener('click', () => {
            const buyButton =
                this.querySelector('.yg-old-buttons .shopify-payment-button .shopify-payment-button__more-options') ||
                this.querySelector('.yg-old-buttons .shopify-payment-button .shopify-payment-button__button--unbranded')
            buyButton?.click()
        })
    }
}

if (!window.customElements.get('yg-card-buttons')) {
    window.customElements.define('yg-card-buttons', YGCardButtons)
}

class YGProductCard extends HTMLElement {
    constructor() {
        super()
        this.init()
    }

    init() {
        let item = this.querySelector('.yg-flash-sale-time')

        if (!item) return

        this.countDown(item)
    }

    countDown(item) {
        let time = item.getAttribute('data-time')
        let hoursItem = this.querySelector('.hours')
        let minutesItem = this.querySelector('.minutes')
        let secondsItem = this.querySelector('.seconds')

        let interval = setInterval(() => {
            time--
            // 计算小时、分钟和秒
            let hours = Math.floor((time) / (60 * 60));
            let minutes = Math.floor((time % (60 * 60)) / (60));
            let seconds = Math.floor((time % (60)));

            if (time >= 0) {
                if (hoursItem.innerHTML != hours) {
                    hoursItem.innerHTML = hours > 9 ? hours : `0${hours}`
                }
                if (minutesItem.innerHTML != minutes) {
                    minutesItem.innerHTML = minutes > 9 ? minutes : `0${minutes}`
                }
                if (secondsItem.innerHTML != seconds) {
                    secondsItem.innerHTML = seconds > 9 ? seconds : `0${seconds}`
                }
            } else {
                clearInterval(interval)
                this.style.display = 'none'
            }
        }, 1000)

    }
}

if (!window.customElements.get('yg-product-card')) {
    window.customElements.define('yg-product-card', YGProductCard)
}

class YGCouponBlock extends YGScriptLoader {
    constructor() {
        super()
        const url = this.getAttribute('data-load-script')
        this.loadScript(url, () => {
            this.init()
        })
    }

    init() {
        let swiperItems = this.querySelectorAll('.yg-coupon-product-list')

        swiperItems.forEach((swiperItem) => {
            this.productsSwiepr(swiperItem)
        })

        this.copyToClipboard()
        this.countDown()
    }

    productsSwiepr(swiperItem) {
        if (!swiperItem) return
        let next = this.querySelector('.swiper-button-next')
        let prev = this.querySelector('.swiper-button-prev')
        let scrollbar = this.querySelector('.swiper-scrollbar')

        let swiper = new Swiper(swiperItem, {
            slidesPerView: 1.1,
            spaceBetween: 12,
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
            scrollbar: {
                el: scrollbar,
            },
            breakpoints: {
                650: {
                    slidesPerView: 2,
                    spaceBetween: 16,
                },
                980: {
                    slidesPerView: 2.5,
                    spaceBetween: 16,
                },
                1150: {
                    slidesPerView: 2,
                    spaceBetween: 16,
                },
                1600: {
                    slidesPerView: 3,
                    spaceBetween: 16,
                }
            }
        })
    }

    copyToClipboard() {
        let textBtn = this.querySelector('.yg-coupon-btn')
        let copyText = textBtn.getAttribute('data-coupon');

        textBtn.addEventListener('click', () => {
            navigator.clipboard.writeText(copyText).then(() => {
                textBtn.innerHTML = 'COPY SUCCESS !'
                setTimeout(() => {
                    textBtn.innerHTML = 'COPY COUPON'
                }, 3000)
            }, () => {
                textBtn.innerHTML = 'COPY FAILURE !'
                setTimeout(() => {
                    textBtn.innerHTML = 'COPY COUPON'
                }, 3000)
            });
        });
    }

    countDown() {
        let countDown = this.getAttribute("data-countdown") * 1000
        setTimeout(() => {
            this.style.display = 'none'
        }, countDown)
    }
}

if (!window.customElements.get('yg-coupon-block')) {
    window.customElements.define('yg-coupon-block', YGCouponBlock)
}

class YGVideoSwiper extends YGScriptLoader {
    constructor() {
        super()
        this.players = []

        const url = this.getAttribute('data-load-script')
        this.loadScript(url, () => {
            this.init()
        })
    }

    init() {
        let imageSwiperItem = this.querySelector('.yg-image-swiper')
        let videoSwiperItem = this.querySelector('.yg-video-swiper')
        this.blockSwiper(imageSwiperItem, videoSwiperItem)
        this.openPopup(imageSwiperItem, videoSwiperItem)
        this.closePopup(imageSwiperItem, videoSwiperItem)
    }

    blockSwiper(imageSwiperItem, videoSwiperItem) {
        let _this = this
        let videoProductSwiperItems = this.querySelectorAll('.yg-video__product-list')
        let next = imageSwiperItem.querySelector('.swiper-button-next')
        let prev = imageSwiperItem.querySelector('.swiper-button-prev')
        let scrollbar = imageSwiperItem.querySelector('.swiper-scrollbar')
        let videoList = videoSwiperItem.querySelectorAll('video')
        let iframeList = videoSwiperItem.querySelectorAll('.yg-youtube__iframe')
        let imageSlides = this.querySelectorAll('.yg-image-swiper .swiper-slide')

        let videoBox = videoSwiperItem.querySelectorAll('.swiper-slide.yg-video__item')

        const initIframes = () => iframeList.forEach(iframe => this.initIframe(iframe))
        if (typeof window.YT?.Player === 'function') {
            initIframes()
        } else {
            const previousYouTubeReady = window.onYouTubeIframeAPIReady
            window.onYouTubeIframeAPIReady = () => {
                previousYouTubeReady?.()
                if (this.isConnected) initIframes()
            }
        }
        const blockSize = this.getAttribute('data-block-size');
        const sp649 = blockSize == 1 ? 1 : 1.1;
        const sp650 = blockSize == 1 ? 1 : 1.99;
        const threeColumns = this.getAttribute('data-desktop-slides') === '3';
        const spDesktop = threeColumns ? Math.min(3, Number(blockSize)) : sp650;
        let imageSwiper = new Swiper(imageSwiperItem, {
            slidesPerView: sp649,
            spaceBetween: 12,
            slideToClickedSlide: true,
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
            pagination: {
                el: scrollbar,
                type: "progressbar"
            },
            breakpoints: {
                650: {
                    slidesPerView: threeColumns ? Math.min(1.5, Number(blockSize)) : sp650,
                    spaceBetween: 16,
                },
                980: {
                    slidesPerView: spDesktop,
                    spaceBetween: 16,
                },
                1150: {
                    slidesPerView: spDesktop,
                    spaceBetween: 16,
                },
                1600: {
                    slidesPerView: spDesktop,
                    spaceBetween: 16,
                }
            },
            slidesPerView: threeColumns ? Math.min(1.5, Number(blockSize)) : 1
        })
        imageSwiper.update();
        let videoSwiper = new Swiper(videoSwiperItem, {
            slidesPerView: 1,
            spaceBetween: 20,
            effect: 'fade',
            navigation: {
                nextEl: '.yg-video-swiper-btn.swiper-button-next',
                prevEl: '.yg-video-swiper-btn.swiper-button-prev',
            },
            on: {
                slideChangeTransitionEnd: function () {
                    if (!videoSwiperItem.classList.contains('hidden')) {
                      videoBox.forEach(video => {
                          let videoUrl = video.querySelector('video')
                          if (videoUrl) {
                              videoUrl.pause()
                              videoUrl.currentTime = 0

                          } else {
                              let iframe = video.querySelector('.yg-youtube__iframe');
                              _this.pauseVideo(iframe.getAttribute("data-id"))
                          }
                      })
                      videoBox[this.activeIndex].querySelector('video')?.play()
                      if (videoBox[this.activeIndex].querySelector('iframe')) {
                          _this.startVideo(videoBox[this.activeIndex].querySelector('iframe').getAttribute("data-id"))
                      }
                    }
                },
                slideChange: function () {
                    // 获取当前活动的幻灯片索引
                    const activeIndex = this.activeIndex;


                    // 移除所有幻灯片上的 yg-active 类
                    imageSlides.forEach((slide) => {
                        slide.classList.remove('yg-active');
                    });

                    // 给当前活动的幻灯片添加 yg-active 类
                    imageSlides[activeIndex].classList.add('yg-active');
                    if (threeColumns) imageSwiper.slideTo(activeIndex);
                }
            }
        })

        // Three visible thumbnails have fewer snap points than the video modal.
        if (!threeColumns) {
            imageSwiper.controller.control = videoSwiper;
            videoSwiper.controller.control = imageSwiper;
        }

        videoProductSwiperItems.forEach(item => {
            let next = item.parentNode.querySelector('.yg-video-product-swiper-btn.swiper-button-next')
            let prev = item.parentNode.querySelector('.yg-video-product-swiper-btn.swiper-button-prev')

            new Swiper(item, {
                slidesPerView: 1,
                spaceBetween: 20,
                navigation: {
                    nextEl: next,
                    prevEl: prev,
                },
                breakpoints: {
                    650: {
                        slidesPerView: 1.2,
                        spaceBetween: 16,
                    },
                    980: {
                        slidesPerView: 1.5,
                        spaceBetween: 16,
                    },
                    1150: {
                        slidesPerView: 2,
                        spaceBetween: 16,
                    },
                    1600: {
                        slidesPerView: 3,
                        spaceBetween: 16,
                    }
                }
            })
        })


    }

    openPopup(imageSwiperItem, videoSwiperItem) {
        let openBtns = imageSwiperItem.querySelectorAll('.yg-video-button')

        openBtns.forEach((openBtn, index) => {
            openBtn.addEventListener('click', (e) => {
                e.preventDefault()
                if (this.getAttribute('data-desktop-slides') === '3') {
                    e.stopPropagation()
                    videoSwiperItem.swiper.slideTo(index, 0)
                }
                let videos = videoSwiperItem.querySelectorAll('.yg-video__item.swiper-slide');

                if (videos[index].querySelector('video')) {
                    videos[index].querySelector('video').play()
                } else {
                    let video = videos[index].querySelector('.yg-youtube__iframe');
                    this.startVideo(video.getAttribute("data-id"))
                    // this.player.playVideo();
                }
                document.querySelector('body').style.overflow = 'hidden'
                videoSwiperItem.classList.remove('hidden')
            })
        })
    }

    closePopup(imageSwiperItem, videoSwiperItem) {
        let closeBtn = videoSwiperItem.querySelector('.yg-video-swiper__close-btn')

        closeBtn.addEventListener('click', (e) => {
            let video = videoSwiperItem.querySelector('.yg-video__item.swiper-slide-active video');
            e.preventDefault()
            if (video) {
                video.pause()
                video.currentTime = 0
            } else {
                let iframe = videoSwiperItem.querySelector('.yg-video__item.swiper-slide-active .yg-youtube__iframe');
                this.pauseVideo(iframe.getAttribute("data-id"))
            }
            document.querySelector('body').style.overflow = 'auto'
            videoSwiperItem.classList.add('hidden')
        })

        videoSwiperItem.addEventListener('click', (e) => {
            if (e.target.classList.contains('yg-video-swiper')) {
                let video = videoSwiperItem.querySelector('.yg-video__item.swiper-slide-active video');
                e.preventDefault()
                if (video) {
                    video.pause()
                    video.currentTime = 0
                } else {
                    let iframe = videoSwiperItem.querySelector('.yg-video__item.swiper-slide-active .yg-youtube__iframe');
                    this.pauseVideo(iframe.getAttribute("data-id"))
                }
                document.querySelector('body').style.overflow = 'auto'
                videoSwiperItem.classList.add('hidden')
            }
        })
    }

    initIframe(iframe) {
        let videoId = iframe.getAttribute("data-id")
        let iframes = new YT.Player(iframe, {
            videoId: videoId,
            height: 'auto',
            events: {
                'onReady': (event) => this.onPlayerReady(event, videoId)
            }
        });
        return iframes
    }

    onPlayerReady(event, videoId) {
        // 播放器就绪时，将播放器对象保存到实例变量中
        if (!this.players[videoId]) {
            this.players[videoId] = event.target;
        }
        // this.players.push({ id: videoId, player: event.target })
    }

    startVideo(playerId) {
        const player = this.players[playerId]
        // console.log(player,player.playVideo);
        if (player && player.pauseVideo) {
            player.playVideo();
        } else {
            console.error('未找到匹配的播放器');
        }
    }

    pauseVideo(playerId) {
        const player = this.players[playerId]
        if (player && player.pauseVideo) {
            player.pauseVideo();
        } else {
            console.error('未找到匹配的播放器');
        }
    }
}

if (!window.customElements.get('yg-video-swiper')) {
    window.customElements.define('yg-video-swiper', YGVideoSwiper)
}


class YGAnchorTab extends HTMLElement {
    constructor() {
        super()
        this.init()
    }

    init() {
        let sectionBox = this.closest('.yg-anchor-section')
        this.calculateTopVlue(sectionBox)
    }

    calculateTopVlue(sectionBox) {
        let sectionTop = sectionBox.nextElementSibling.getBoundingClientRect().top + window.scrollY
        let buttonList = sectionBox.querySelector('.yg-product-description__variant')
        let productDes = sectionBox.querySelector('.yg-product-description')
        let announcementBar = document.querySelector('.shopify-section--announcement-bar');

        let scrollTimer;
        let ygSectionList = document.querySelectorAll('#main .shopify-section'),
            ygProductTab = this.querySelectorAll('li');

        ygProductTab.forEach(function (e) {
            e.onclick = function () {
                // 获取点击项的data-section-number属性值
                let number = e.getAttribute('data-section-number');
                // 遍历ygProductTab，移除所有激活类
                ygProductTab.forEach((a) => {
                    a.classList.remove('active');
                });
                // 给当前点击项添加激活类
                e.classList.add('active');
                if (number) {
                    // 通过属性值获取dom节点
                    let pointDom = ygSectionList[number];
                    // 计算滚动距离
                    let pointTop =
                        pointDom.offsetTop - parseInt(sectionBox.style.top) - sectionBox.getBoundingClientRect().height - 30;
                    // 滑动到指定dom节点
                    window.scrollTo({
                        top: pointTop,
                        behavior: 'smooth',
                    });
                }
            };
        });

        // 添加滚动事件监听器
        window.addEventListener('scroll', function () {
            // 清除之前的定时器
            clearTimeout(scrollTimer);

            // 设置新的定时器
            scrollTimer = setTimeout(function () {
                // 在页面滚动停止后执行的操作
                const headerSection = document.querySelector('.shopify-section--header');
                let {height, top} = headerSection.getBoundingClientRect();
                // 剩下的代码保持不变
                if (headerSection) {
                    let btnBoxTop = height + top >= 0 ? height - 1 + top : 0;
                    sectionBox.style.top = btnBoxTop + 'px';
                }

                if (sectionTop > window.scrollY) {
                    buttonList.classList.add('hidden')
                    productDes.style.display = 'none'
                } else {
                    if (buttonList && productDes) {
                        buttonList.classList.remove('hidden')
                        productDes.style.display = 'flex'
                    }
                    if (announcementBar) {
                        sectionBox.style.paddingTop = window.getComputedStyle(announcementBar).height
                    }
                }
            }, 100); // 这里的 250 是延迟时间，单位为毫秒

            const options = {
                threshold: [0.7]
            }
            const intersectionObserver = new IntersectionObserver((entries) => {
                // and we do not need to do anything.
                if (entries[0].intersectionRatio > 0.7) {
                    ygProductTab.forEach((productTab) => {

                        if (entries[0].target.getAttribute('data-section-number') == productTab.getAttribute('data-section-number')) {
                            ygProductTab.forEach((a) => {
                                a.classList.remove('active');
                            });
                            // 给当前点击项添加激活类
                            productTab.classList.add('active');
                        }
                    });
                }
            }, options);
            // start observing
            ygSectionList.forEach(function (Section, i) {
                Section.setAttribute("data-section-number", i)
                intersectionObserver.observe(Section);
            })

        });
    }
}

if (!window.customElements.get('yg-anchor-tab')) {
    window.customElements.define('yg-anchor-tab', YGAnchorTab)
}

class YGAnchorTab2 extends HTMLElement {
    constructor() {
        super()
        this.init()
    }

    init() {
        let sectionBox = this.closest('.yg-anchor-section')
        this.calculateTopVlue(sectionBox)
    }

    calculateTopVlue(sectionBox) {
        let announcementBar = document.querySelector('.shopify-section--announcement-bar');

        let ygSectionList = document.querySelectorAll('#main .shopify-section'),
            ygProductTab = this.querySelectorAll('li');

        ygProductTab.forEach(function (e) {
            e.onclick = function () {
                // 获取点击项的data-section-number属性值
                let number = e.getAttribute('data-section-number');
                // 遍历ygProductTab，移除所有激活类
                ygProductTab.forEach((a) => {
                    a.classList.remove('active');
                });
                // 给当前点击项添加激活类
                e.classList.add('active');
                if (number) {
                    // 通过属性值获取dom节点
                    let pointDom = ygSectionList[number];
                    // 计算滚动距离
                    let pointTop =
                        pointDom.offsetTop - parseInt(sectionBox.style.top) - sectionBox.getBoundingClientRect().height;
                    // 滑动到指定dom节点
                    window.scrollTo({
                        top: pointTop,
                        behavior: 'smooth',
                    });
                }
            };
        });

        if (announcementBar && sectionBox.getBoundingClientRect().top <= announcementBar.getBoundingClientRect().height) {
            sectionBox.style.paddingTop = window.getComputedStyle(announcementBar).height
        } else {
            sectionBox.style.paddingTop = 0
        }

        // 添加滚动事件监听器
        window.addEventListener('scroll', function () {
            const headerSection = document.querySelector('.shopify-section--header');
            let {height, top} = headerSection.getBoundingClientRect();
            // 剩下的代码保持不变
            if (headerSection) {
                let btnBoxTop = height + top >= 0 ? height - 1 + top : 0;
                sectionBox.style.top = btnBoxTop + 'px';
            }

            if (announcementBar && sectionBox.getBoundingClientRect().top <= announcementBar.getBoundingClientRect().height) {
                sectionBox.style.paddingTop = window.getComputedStyle(announcementBar).height
            } else {
                sectionBox.style.paddingTop = 0
            }
            const options = {
                threshold: [0.7]
            }
            const intersectionObserver = new IntersectionObserver((entries) => {
                // and we do not need to do anything.
                if (entries[0].intersectionRatio > 0.7) {
                    ygProductTab.forEach((productTab) => {

                        if (entries[0].target.getAttribute('data-section-number') == productTab.getAttribute('data-section-number')) {
                            ygProductTab.forEach((a) => {
                                a.classList.remove('active');
                            });
                            // 给当前点击项添加激活类
                            productTab.classList.add('active');
                        }
                    });
                }
            }, options);
            // start observing
            ygSectionList.forEach(function (Section, i) {
                Section.setAttribute("data-section-number", i)
                intersectionObserver.observe(Section);
            })
        });
    }
}

if (!window.customElements.get('yg-anchor-tab2')) {
    window.customElements.define('yg-anchor-tab2', YGAnchorTab2)
}

class YGAnimation extends HTMLElement {
    static #scrollCallbacks = [];
    static #registered = false

    constructor() {
        super();
        // 监听滚动事件
        if (!YGAnimation.#registered) {
            window.addEventListener('scroll', YGAnimation.handleScroll);
            YGAnimation.#registered = true;
        }

        // 注册滚动事件
        Object.defineProperty(this, 'registerScrollEvent', {
            value: function (fn) {
                YGAnimation.#scrollCallbacks.push(fn);
            },
            writable: true,
            configurable: false
        });

        // 获取动画元素
        this.animationEles = Array.from(this.querySelectorAll('.yg-animation-element'));
        this.animationEles.forEach(ele => {
            ele.animationflag = false;
        })

        this.enterEvent();
        this.registerScrollEvent(this.enterEvent.bind(this));
    }

    static handleScroll = () => {
        YGAnimation.#scrollCallbacks.forEach(fn => fn());
    };

    enterEvent() {
        this.animationEles?.forEach(ele => {
            if (ele?.getBoundingClientRect().top < window.innerHeight * 0.8 && !ele.animationflag) {
                ele.animationflag = true;
                if (ele.fn) {
                    if (ele.delay) {
                        setTimeout(() => {
                            ele.fn(ele);
                        }, ele.delay);
                    } else {
                        ele.fn(ele);
                    }
                } else {
                    this.toFunction(ele)
                }
            }
        })
    }

    toFunction(ele) {
        ele.style.opacity = 1;
        ele.style.transform = 'translateY(0)';
    }
}

if (!window.customElements.get('yg-animation')) {
    window.customElements.define('yg-animation', YGAnimation)
}

class YGReviewsSwiper extends YGScriptLoader {
    constructor() {
        super()
        this.init() // 调用自定义方法
    }

    init() {
        // 这里放置自定义逻辑
        this.reviewsSwiper()
    }

    reviewsSwiper() {
        new Swiper(this, {
            slidesPerView: 1,
            spaceBetween: 20,
            breakpoints: {
                700: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
                1150: {
                    slidesPerView: 1.3,
                    spaceBetween: 60,
                },
                1680: {
                    slidesPerView: 1.5,
                    spaceBetween: 100,
                }
            },
            scrollbar: {
                el: ".swiper-scrollbar",
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });
    }
}

document.addEventListener("DOMContentLoaded", function () {

    if (!window.customElements.get('yg-reviews-swiper')) {
        window.customElements.define('yg-reviews-swiper', YGReviewsSwiper)
    }
})

class YGCopy extends HTMLElement {
    constructor() {
        super();
        this.init()
    }

    init() {
        this.addEventListener('click', function (e) {
            const text = this.querySelector('.yg-policy-text').textContent.trim();
            navigator.clipboard.writeText(text).then(() => {
                this.querySelector('.yg-copy-tip').style.opacity = 1;
                setTimeout(() => {
                    this.querySelector('.yg-copy-tip').style.opacity = 0;
                }, 500);
            }).catch(err => {
                console.error('复制失败:', err);
            });
        })
    }
}

if (!window.customElements.get('yg-copy')) {
    window.customElements.define('yg-copy', YGCopy);
}

class YGBundleWrapper extends HTMLElement {
    static productData = []

    constructor() {
        super()
        this.init()
    }

    init() {
        this.toggledClass()
        this.totalPrices()
        this.addToCart()
        this.closeErrorPopup()
        this.collapseTable()
    }

    toggledClass() {
        this.querySelectorAll('.yg-bundle-item').forEach(item => {
            item.addEventListener('click', (e) => {
                e.stopPropagation();
                e.preventDefault();
                let $link = item.querySelector('.yg-bundle-link')
                let url = $link.getAttribute('href');

                if (e.target == $link || e.target.closest(".yg-bundle-link") == $link) {
                    window.location.href = url;
                    return;
                }

                if (item.classList.contains('active-required')) {
                    return;
                }

                const activeProductItem = this.querySelector('.yg-bundle-item.yg-bundle-product.active');

                if (activeProductItem && !item.classList.contains('yg-bundle-product')) {
                    activeProductItem.classList.remove('active');
                }

                item.classList.toggle('active');

                const bundleItems = this.querySelectorAll('.yg-bundle-item');
                if (item.classList.contains('yg-bundle-product')) {
                    this.querySelectorAll('.yg-bundle-item.active').forEach(activeItem => {
                        if (activeItem !== item && activeItem.classList.contains('cannot-exist-product')) {
                            activeItem.classList.remove('active');
                        }
                    });
                    bundleItems.forEach(activeItem => {
                        if (item.classList.contains('active')) {
                            if (activeItem !== item && activeItem.classList.contains('cannot-exist-product')) {
                                activeItem.classList.add('forbidden-item');
                            }
                        } else {
                            if (activeItem !== item && activeItem.classList.contains('cannot-exist-product')) {
                                activeItem.classList.remove('forbidden-item');
                            }
                        }
                    });
                }
                if (item.classList.contains('cannot-exist-product')) {
                    bundleItems.forEach(activeItem => {
                        if (item.classList.contains('active')) {
                            if (activeItem !== item && activeItem.classList.contains('yg-bundle-product')) {
                                activeItem.classList.add('forbidden-item');
                            }
                        } else {
                            if (activeItem !== item && activeItem.classList.contains('yg-bundle-product')) {
                                activeItem.classList.remove('forbidden-item');
                            }
                        }
                    });
                }

                this.totalPrices();
            });
        });


        this.querySelectorAll('.yg-bundle-variants .variant-picker__option .yg-bundle-swatch').forEach(input => {
            input.addEventListener('click', (e) => {
                e.stopPropagation();
                e.preventDefault();
                const parentItem = input.closest('.yg-bundle-item');
                this.querySelectorAll('.yg-bundle-variants .variant-picker__option .yg-bundle-swatch').forEach(btn => {
                    btn.classList.remove('active');
                });
                input.classList.add('active');
                this.handleVariantSelection(input, parentItem);
                this.handleBundleItemState(parentItem);
            });
        });

        this.querySelectorAll(".yg-variant-picker").forEach(button => {
            button.addEventListener('click', (e) => {
                e.stopPropagation();
                e.preventDefault();
                const parentItem = button.closest('.yg-bundle-item');
                button.classList.toggle('active');
                parentItem.classList.add('active');
                this.handleBundleItemState(parentItem);
                const $list = parentItem.querySelector('.yg-bundle-variant-list');
                if ($list) {
                    $list.classList.toggle('active');
                }
                this.totalPrices();
            });
        });

        this.querySelectorAll('.yg-bundle-variant-list li').forEach(item => {
            item.addEventListener('click', (e) => {
                e.stopPropagation();
                e.preventDefault();
                const parentItem = item.closest('.yg-bundle-item');
                this.handleVariantSelection(item, parentItem);
                const $text = item.textContent;
                const $button = item.closest('.yg-bundle-item').querySelector('.yg-variant-picker');
                $button.classList.remove('active');
                $button.querySelector('span').textContent = $text;
                $button.setAttribute('title', $text);
                const $list = item.closest('.yg-bundle-variant-list');
                $list.classList.remove('active');
            })
        })

        document.addEventListener('click', () => {
            this.querySelectorAll(".yg-variant-picker").forEach(button => {
                if (button.classList.contains('active')) {
                    button.classList.remove('active');
                    const parentItem = button.closest('.yg-bundle-item');
                    const $list = parentItem.querySelector('.yg-bundle-variant-list');
                    $list.classList.remove('active');
                }
            });
        });
    }

    handleBundleItemState(parentItem) {
        if (parentItem.classList.contains('yg-bundle-product')) {
            this.querySelectorAll('.yg-bundle-item.active').forEach(activeItem => {
                if (activeItem !== parentItem && activeItem.classList.contains('cannot-exist-product')) {
                    activeItem.classList.remove('active');
                    const activeList = activeItem.querySelector('.yg-bundle-variant-list');
                    if (activeList) activeList.classList.remove('active');
                }
            });
            this.querySelectorAll('.yg-bundle-item').forEach(activeItem => {
                if (parentItem.classList.contains('active')) {
                    if (activeItem !== parentItem && activeItem.classList.contains('cannot-exist-product')) {
                        activeItem.classList.add('forbidden-item');
                    }
                } else {
                    if (activeItem !== parentItem && activeItem.classList.contains('cannot-exist-product')) {
                        activeItem.classList.remove('forbidden-item');
                    }
                }
            });
        } else {
            const activeProductItem = this.querySelector('.yg-bundle-item.yg-bundle-product.active');
            if (activeProductItem && parentItem.classList.contains('cannot-exist-product')) {
                activeProductItem.classList.remove('active');
                const activeProductList = activeProductItem.querySelector('.yg-bundle-variant-list');
                if (activeProductList) activeProductList.classList.remove('active');
            }

            if (parentItem.classList.contains('cannot-exist-product')) {
                this.querySelectorAll('.yg-bundle-item').forEach(activeItem => {
                    if (parentItem.classList.contains('active')) {
                        if (activeItem !== parentItem && activeItem.classList.contains('yg-bundle-product')) {
                            activeItem.classList.add('forbidden-item');
                        }
                    } else {
                        if (activeItem !== parentItem && activeItem.classList.contains('yg-bundle-product')) {
                            activeItem.classList.remove('forbidden-item');
                        }
                    }
                });
            }
        }
    }

    handleVariantSelection(input, parentItem) {
        parentItem.classList.add('active');
        if (parentItem) {
            const productHandle = parentItem.getAttribute('data-product-handle');
            const variantId = input.getAttribute('data-variant-id');

            if (productHandle && variantId) {
                fetch(window.Shopify.routes.root + `products/${productHandle}.js`)
                    .then(response => {
                        if (!response.ok) {
                            throw new Error(`Failed to fetch product: ${response.statusText}`);
                        }
                        return response.json();
                    })
                    .then(product => {
                        const matchingVariant = product.variants.find(variant => variant.id.toString() === variantId);
                        // console.log("matchingVariant: ", JSON.stringify(matchingVariant, null, 2));
                        const productAvailable = matchingVariant.available;
                        // console.log("productAvailable: ", productAvailable)
                        if (productAvailable === false) {
                            input.classList.add('disabled');
                            const message = `Sorry, this variant is currently unavailable.`;
                            this.showErrorPopup(message);
                        } else {
                            input.classList.remove('disabled');
                            this.hideErrorPopup();
                        }
                        const salePrice = parentItem.querySelector(".yg-bundle-price sale-price");
                        const comparePrice = parentItem.querySelector(".yg-bundle-price compare-at-price");
                        const productCurrency = parentItem.getAttribute("data-currency").split(' ')[1];

                        parentItem.setAttribute("data-product-id", matchingVariant.id);
                        salePrice.textContent = `${productCurrency} $${(matchingVariant.price / 100).toFixed(2)}`;
                        salePrice.setAttribute('data-price', matchingVariant.price);
                        if (matchingVariant.compare_at_price) {
                            if (comparePrice) {
                                comparePrice.textContent = `${productCurrency} $${(matchingVariant.compare_at_price / 100).toFixed(2)}`;
                                comparePrice.setAttribute('data-price', matchingVariant.compare_at_price)
                            } else {
                                const newComparePrice = document.createElement('compare-at-price');
                                newComparePrice.setAttribute('data-price', matchingVariant.compare_at_price);
                                newComparePrice.textContent = `${productCurrency} $${(matchingVariant.compare_at_price / 100).toFixed(2)}`;
                                parentItem.querySelector(".yg-bundle-price").appendChild(newComparePrice);
                                newComparePrice.setAttribute('data-price', matchingVariant.compare_at_price)
                            }
                        } else {
                            if (comparePrice) {
                                comparePrice.remove();
                            }
                        }
                        this.totalPrices();
                    })
                    .catch(error => {
                        console.error('Error fetching product:', error);
                    });
            }
        }
    }

    showErrorPopup(message) {
        const errorPopup = this.querySelector('.error-popup');
        const errorMessage = errorPopup.querySelector('.error-message');
        errorMessage.textContent = message;
        errorPopup.classList.add('active');
    }

    hideErrorPopup() {
        const errorPopup = this.querySelector('.error-popup');
        errorPopup.classList.remove('active');
    }

    collapseTable() {
        const buttons = document.querySelectorAll(".yg-bundle-table-btn");
        const tables = document.querySelectorAll(".yg-bundle-table");
        buttons.forEach((button, index) => {
            button.addEventListener("click", (e) => {
                button.classList.toggle("active");
                tables[index].classList.toggle("active");
            })
        })
    }

    closeErrorPopup() {
        const button = this.querySelector('.error-exit-button');
        const errorPopup = this.querySelector('.error-popup');

        button.addEventListener("click", () => {
            errorPopup.classList.remove('active');
        });

        document.addEventListener('click', (e) => {
            if (!errorPopup.contains(e.target) && !button.contains(e.target)) {
                errorPopup.classList.remove('active');
            }
        });
    }

    totalPrices() {
        let activeProducts = this.querySelectorAll('.yg-bundle-item.active');
        let totalPrice = 0;
        let totalComparePrice = 0;
        YGBundleWrapper.productData = []

        activeProducts.forEach(active => {
            let salePrice = active.querySelector('.yg-bundle-price sale-price')?.getAttribute('data-price') || 0;
            let comparePrice = active.querySelector('.yg-bundle-price compare-at-price')?.getAttribute('data-price') || active.querySelector('.yg-bundle-price sale-price')?.getAttribute('data-price') || 0;
            totalPrice += parseInt(salePrice);
            totalComparePrice += parseInt(comparePrice);

            YGBundleWrapper.productData.push({
                'id': active.getAttribute('data-product-id'),
                'quantity': 1
            })
        })

        let totalPriceBox = this.querySelector('.yg-bundle-total-price')
        // let currency = totalPriceBox.getAttribute('data-currency').split(' ')[1];
        let totalCompareBox = this.querySelector('.yg-bundle-compare-price');
        let headerPrice = this.closest('.section-yg-bundle').querySelector('.yg-bundle-header-price');

        let savePrice = this.querySelector('.yg-bundle-save-price');
        totalPriceBox.innerHTML = `$${(totalPrice / 100).toFixed(2)}`;
        totalCompareBox.innerHTML = `$${(totalComparePrice / 100).toFixed(2)}`;
        const savedAmount = ((totalComparePrice - totalPrice) / 100).toFixed(2);

        if (parseFloat(savedAmount) === 0) {
            savePrice.classList.add('hidden');
            totalCompareBox.classList.add('hidden');
        } else {
            savePrice.classList.remove('hidden');
            totalCompareBox.classList.remove('hidden');
        }
        savePrice.innerHTML = `Save $${savedAmount}`;
        headerPrice.innerHTML = `$${((totalComparePrice - totalPrice) / 100).toFixed(2)}`;
    }

    addToCart() {
        this.querySelector('.yg-bundle-buy-button').addEventListener('click', (e) => {
            console.log("YGBundleWrapper.productData: ", YGBundleWrapper.productData)
            e.preventDefault();
            const button = e.target.closest('.yg-bundle-buy-button');

            button.setAttribute('aria-busy', 'true');
            button.disabled = true;
            let sectionsToBundle = ["variant-added"];
            document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", {
                bubbles: true,
                detail: {sections: sectionsToBundle}
            }));
            let formData = {
                'items': YGBundleWrapper.productData,
                'sections': sectionsToBundle.join(",")
            };
            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
                .then(async response => {
                    if (response.ok) {
                        const responseJson = await response.json();
                        if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
                            return window.location.href = `${Shopify.routes.root}cart`;
                        }
                        const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
                        cartContent["sections"] = responseJson["sections"];

                        this.dispatchEvent(new CustomEvent("variant:add", {
                            bubbles: true,
                            detail: {
                                items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
                                cart: cartContent
                            }
                        }));
                        document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                            bubbles: true,
                            detail: {
                                baseEvent: "variant:add",
                                cart: cartContent
                            }
                        }));
                    } else {
                        const responseJson = await response.json();
                        // console.log(responseJson["description"]);
                        this.showErrorPopup(responseJson["description"]);
                        this.dispatchEvent(new CustomEvent("yg_cart:error", {
                            bubbles: true,
                            detail: {
                                error: responseJson["description"]
                            }
                        }));
                        document.dispatchEvent(new CustomEvent("cart:refresh"));
                    }
                })
                .catch((error) => {
                    this.showErrorPopup(error);
                    console.error('Error:', error);
                })
                .finally(() => {
                    button.removeAttribute('aria-busy');
                    button.disabled = false;
                });
        })
    }
}

if (!window.customElements.get('yg-bundle-wrapper')) {
    window.customElements.define('yg-bundle-wrapper', YGBundleWrapper)
}

document.addEventListener('DOMContentLoaded', function () {
    const $videoWrapper = document.querySelectorAll('.yg-media-grid video-media');
    if ($videoWrapper.length > 0) {
        $videoWrapper.forEach(wrapper => {
            const placeholder = wrapper.querySelector('img');
            const video = wrapper.querySelector('video');
            const iframe = wrapper.querySelector('iframe');

            if (video) {
                video.addEventListener('loadeddata', () => {
                    if (placeholder) {
                        placeholder.style.display = 'none';
                        placeholder.style.opacity = '0';
                        placeholder.style.visibility = 'hidden';
                    }
                    video.style.display = 'block';
                });
            }

            if (iframe) {
                iframe.addEventListener('load', () => {
                    if (placeholder) {
                        placeholder.style.display = 'none';
                        placeholder.style.opacity = '0';
                        placeholder.style.visibility = 'hidden';
                    }
                    iframe.style.display = 'block';
                });
            }
        });
    }

});
class ProductVariantDetails extends HTMLElement {
    constructor() {
        super();
        this._onVariantChange = this._onVariantChange.bind(this);
    }

    connectedCallback() {
        if (this._isConnected) return;

        this._isConnected = true;
        this._form = document.getElementById(this.dataset.formId);
        this._shortOutput = document.querySelector('[data-variant-details-short-output][data-form-id="' + this.dataset.formId + '"]');
        this._specificationsSection = this.querySelector('[data-variant-details-specifications-section]');
        this._specificationsOutput = this.querySelector('[data-variant-details-specifications-output]');
        this._descriptionSection = this.querySelector('[data-variant-details-description-section]');
        this._descriptionOutput = this.querySelector('[data-variant-details-description-output]');
        this._descriptionFallback = this.querySelector('[data-variant-details-description-fallback]');
        this._variantTemplates = new Map(
            Array.from(this.querySelectorAll('[data-variant-details-template]')).map((template) => [
                String(template.dataset.variantId),
                template
            ])
        );

        this._form?.addEventListener('variant:change', this._onVariantChange);
        this._renderVariant(this.dataset.currentVariantId);
    }

    disconnectedCallback() {
        this._form?.removeEventListener('variant:change', this._onVariantChange);
        this._isConnected = false;
    }

    _onVariantChange(event) {
        this._renderVariant(event.detail.variant?.id);
    }

    _renderVariant(variantId) {
        const template = variantId ? this._variantTemplates.get(String(variantId)) : null;
        const shortSource = template?.content.querySelector('[data-variant-details-short]');
        const specificationsSource = template?.content.querySelector('[data-variant-details-specifications]');
        const descriptionSource = template?.content.querySelector('[data-variant-details-description]');

        this._renderShortDescription(shortSource);
        const hasSpecifications = this._renderSpecifications(specificationsSource);
        const hasDescription = this._renderDescription(descriptionSource);

        this.hidden = !hasSpecifications && !hasDescription;
    }

    _renderShortDescription(source) {
        if (!this._shortOutput) return false;

        const items = (source?.textContent || '')
            .split(',')
            .map((item) => item.trim())
            .filter(Boolean);
        const fragment = document.createDocumentFragment();

        items.forEach((text) => {
            const item = document.createElement('span');
            item.className = 'product-variant-details__short-item text-sm';
            item.textContent = text;
            fragment.append(item);
        });

        this._shortOutput.replaceChildren(fragment);
        this._shortOutput.hidden = items.length === 0;
        return items.length > 0;
    }

    _renderSpecifications(source) {
        const rows = this._getSpecificationRows(source);
        const fragment = document.createDocumentFragment();

        rows.forEach((text) => {
            const separatorIndex = text.indexOf('|');
            const label = separatorIndex >= 0 ? text.slice(0, separatorIndex).trim() : '';
            const value = separatorIndex >= 0 ? text.slice(separatorIndex + 1).trim() : '';

            if (label && value) {
                const row = document.createElement('dl');
                const term = document.createElement('dt');
                const description = document.createElement('dd');

                row.className = 'product-variant-details__spec-row';
                term.textContent = label;
                description.textContent = value;
                row.append(term, description);
                fragment.append(row);
            } else {
                const fallback = document.createElement('p');
                fallback.className = 'product-variant-details__spec-fallback';
                fallback.textContent = text;
                fragment.append(fallback);
            }
        });

        const hasContent = fragment.childNodes.length > 0;
        this._specificationsOutput.replaceChildren(fragment);
        this._specificationsSection.hidden = !hasContent;
        return hasContent;
    }

    _getSpecificationRows(source) {
        if (!source) return [];

        const listItems = Array.from(source.querySelectorAll('li'));
        const rowSources = listItems.length > 0
            ? listItems
            : Array.from(source.querySelectorAll('p'));
        const blocks = rowSources.length > 0 ? rowSources : [source];

        return blocks.flatMap((block) => {
            const clone = block.cloneNode(true);
            clone.querySelectorAll('br').forEach((lineBreak) => lineBreak.replaceWith('\n'));

            return clone.textContent
                .split(/\r?\n/)
                .map((line) => line.replace(/\s+/g, ' ').trim())
                .filter(Boolean);
        });
    }

    _renderDescription(source) {
        const selectedSource = this._hasContent(source) ? source : this._descriptionFallback?.content;
        const hasContent = this._hasContent(selectedSource);

        this._descriptionOutput.replaceChildren(
            ...(hasContent ? Array.from(selectedSource.cloneNode(true).childNodes) : [])
        );
        this._descriptionSection.hidden = !hasContent;
        return hasContent;
    }

    _hasContent(source) {
        if (!source) return false;
        return Boolean(
            source.textContent.trim() ||
            source.querySelector?.('img, video, iframe, table, ul, ol')
        );
    }
}

if (!window.customElements.get('product-variant-details')) {
    window.customElements.define('product-variant-details', ProductVariantDetails);
}
